import { useEffect, useRef } from "react"

import { useSearchParams } from "react-router-dom"

import { ToastrHelper } from "@front-shared/helpers/toastr.helper"

import { GENERAL_CONFIG } from "../config/general.config"

export const useFlashMessage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const processedRef = useRef<string | null>(null)

    // useSearchParams can return a new object reference on render, so depend on
    // the serialized value to avoid re-running this root hook unnecessarily.
    const searchParamsString = searchParams.toString()

    useEffect(() => {
        const params = new URLSearchParams(searchParamsString)
        const flashMessage = params.get(
            GENERAL_CONFIG.urlSearchParamsKeys.flashMessage,
        )

        if (typeof flashMessage !== "string") {
            processedRef.current = null

            return
        }

        // React 18 Strict Mode can run mount effects twice before navigation
        // updates the URL, so guard against showing the same flash twice.
        // Note though that we don't currently have Strict Mode enabled,
        // so this is mostly a precaution.
        if (processedRef.current === searchParamsString) {
            return
        }

        processedRef.current = searchParamsString

        ToastrHelper.warning(flashMessage, undefined, false)

        params.delete(GENERAL_CONFIG.urlSearchParamsKeys.flashMessage)

        setSearchParams(params, { replace: true })
    }, [searchParamsString, setSearchParams])
}
